import React from 'react';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

/**
 * 将表格数据导出为 PDF（使用 html2canvas 确保中文正常显示）
 * @param {Object} options
 * @param {string} options.title - 文档标题
 * @param {string[]} options.headers - 表头列名
 * @param {string[][]} options.rows - 表格行数据（二维数组，每行对应 headers 的列）
 * @param {string} [options.filename] - 下载文件名
 */
function escapeHtml(str) {
  if (str == null) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export async function exportTableToPDF({ title, headers, rows, filename = 'export.pdf' }) {
  const div = document.createElement('div');
  div.style.cssText = 'position:fixed;left:-9999px;top:0;padding:8px;font-family:Microsoft YaHei,SimSun,sans-serif;font-size:9px;background:#fff;';
  div.innerHTML = `
    <div style="margin-bottom:8px;font-weight:bold;font-size:10px;">${escapeHtml(title)}</div>
    <table border="1" cellpadding="10" cellspacing="0" style="border-collapse:collapse;width:100%;font-size:7px;">
      <thead>
        <tr style="background:#428bca;color:#fff;">
          ${headers.map(h => `<th style="border:1px solid #ddd;padding:8px 12px;">${escapeHtml(h)}</th>`).join('')}
        </tr>
      </thead>
      <tbody>
        ${rows.map(row => `
          <tr>
            ${row.map(cell => `<td style="border:1px solid #ddd;padding:8px 12px;">${escapeHtml(cell)}</td>`).join('')}
          </tr>
        `).join('')}
      </tbody>
    </table>
  `;
  document.body.appendChild(div);

  try {
    const canvas = await html2canvas(div, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
    });
    document.body.removeChild(div);

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
    const pdfW = pdf.internal.pageSize.getWidth();
    const pdfH = pdf.internal.pageSize.getHeight();
    const imgW = canvas.width;
    const imgH = canvas.height;
    const ratio = Math.min(pdfW / imgW, pdfH / imgH) * 0.95;
    const w = imgW * ratio;
    const h = imgH * ratio;
    pdf.addImage(imgData, 'PNG', (pdfW - w) / 2, 10, w, h);
    pdf.save(filename);
  } catch (err) {
    document.body.removeChild(div);
    throw err;
  }
}

function PDFViewer() {
  const pdfUrl = "/download/软件技术服务协议.pdf";

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <iframe
        src={pdfUrl}
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        title="PDF Viewer"
      />
    </div>
  );
}

export default PDFViewer;